import eventsController from './eventsController'

export default eventsController



// WEBPACK FOOTER //
// ../src/controllers/eventsController/index.js